import Communication from "./communication";
import "./App.scss";
import { Communication as CommunicationModel } from "./model/communication";
import { useState, useEffect } from "react";
import { AnnotationScheme } from "./annotation/scheme";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { entity_mention_annotation_scheme, situation_mention_annotation_scheme, entity_referent_annotation_scheme, situation_referent_annotation_scheme, logoSVG, entity_mention_data, situation_mention_data } from './constants';
import { Button } from "react-bootstrap";


export default function App() {
	const [communication, setCommunication] = useState(
		require("./test_data/json-data/serif_dog-bites-man.json")
	);
	const [annotationScheme, setAnnotationScheme] = useState(
		require("./annotation-scheme/sample-situation-referent-annotation-scheme.json")
	);

	// Loads communication and annotationScheme from Turk window.
	useEffect(() => {
		const turk_comm = document.querySelector(
			"#communication_input"
		) as HTMLElement;
		if (turk_comm) {
			turk_comm.style.display = "none";
		}
		const turk_anno_scheme = document.querySelector(
			"#annotation_scheme_input"
		) as HTMLElement;
		if (turk_anno_scheme) {
			turk_anno_scheme.style.display = "none";
		}

		const hiddenSubmit = document.querySelector(
			"#hiddenSubmit"
		) as HTMLElement;
		if (hiddenSubmit) {
			hiddenSubmit.style.display = "none";

			const turk_user_interactions = document.querySelector(
				"#user_interactions_input"
			) as HTMLElement;
			turk_user_interactions.style.display = "none";
			setCommunication(() => {
				return { ...(window.communication as CommunicationModel) };
			});
			setAnnotationScheme(() => {
				return { ...(window.annotation_scheme as AnnotationScheme) };
			});
		}
	}, []);

	function renderCommunication(_annotationScheme: AnnotationScheme, communication: CommunicationModel) {
		const className = "selection";
		return (
			<div className="App">
				<div className={className}>
					<Communication
						{...communication}
						activeStructureIds={[]}
						annotationScheme={_annotationScheme}
						communication={communication as CommunicationModel}
					/>
				</div>
			</div>
		);
	}

	function LandingPage() {
		return (
			<div className="home">
				<div className="logo" />
				<div className="buttons">
					<Button className={"button"} onClick={() => window.open("/entity-mention")}>Entity Mention Annotation</Button>
					<Button className={"button"} onClick={() => window.open("/situation-mention")}>Situation Mention Annotation</Button>
					<Button className={"button"} onClick={() => window.open("/entity-referent")}>Entity Coreference Annotation</Button>
					<Button className={"button"} onClick={() => window.open("/situation-referent")}>Situation Coreference Annotation</Button>
				</div>
				<div className="footer">
					<div className="factslab-logo" />
					<div className="note">
						Presented by <a href="http://factslab.io/">FACTS Lab</a>.
					</div>
				</div>
			</div>
		);
	}

	function render() {
		return (
			<BrowserRouter>
				<Routes>
					<Route path="/">
						<Route index element={<LandingPage />} />
						<Route path="entity-mention" element={renderCommunication(entity_mention_annotation_scheme as AnnotationScheme, entity_mention_data as CommunicationModel)} />
						<Route path="situation-mention" element={renderCommunication(situation_mention_annotation_scheme as AnnotationScheme, situation_mention_data as CommunicationModel)} />
						<Route path="entity-referent" element={renderCommunication(entity_referent_annotation_scheme as AnnotationScheme, entity_mention_data as CommunicationModel)} />
						<Route path="situation-referent" element={renderCommunication(situation_referent_annotation_scheme as AnnotationScheme, situation_mention_data as CommunicationModel)} />
					</Route>
				</Routes>
			</BrowserRouter>
		);
	}

	return render();
}
